// Form responses list
exports.CLAIM = 'claim';
exports.PROCEDURE = 'procedure';
exports.PENDING = 'pending';
exports.FINISHED = 'finished';
exports.UNSUBSCRIBED = 'unsubscribed';
exports.SUBSCRIBED = 'subscribed';
exports.SUBSCRIBED_FROM_UTILITY = 'subscribed_from_utility';
exports.FIELD_LABEL = 'Fields::Label';
exports.FIELD_URL = 'Fields::Url';
exports.FIELD_CHECKBOX = 'Fields::Checkbox';
exports.FIELD_IMAGE_LABEL = 'Fields::ImageLabel';
exports.FIELD_MAP = 'Fields::Map';
exports.FIELD_SELECT = 'Fields::Select';
exports.FIELD_DATE = 'Fields::Date';
exports.FIELD_PHONE = 'Fields::Phone';
exports.FIELD_TEXT_AREA = 'Fields::TextArea';
exports.FIELD_IMAGE = 'Fields::Image';
exports.FIELD_PASSWORD = 'Fields::Password';
exports.FIELD_CAPTCHA = 'Fields::Captcha';
exports.FIELD_TEXT = 'Fields::Text';
exports.FIELD_EMAIL = 'Fields::Email';
exports.FIELD_RADIO = 'Fields::Radio';
exports.FIELD_FORM_LINK = 'Fields::FormLink';
exports.FIELD_CREDIT_CARD = 'Fields::CreditCard';
exports.FIELD_ANIMATED_CREDIT_CARD = 'Fields::AnimatedCreditCard';
exports.FIELD_CHECKLIST = 'Fields::Checklist';
exports.RADIO = 'radio';
exports.DATE = 'date';
exports.NUMBER = 'number';
exports.BILL = 'bill';
exports.FORM_RESPONSE = 'form_response';
exports.PROCEDURE = 'procedure';
exports.CLAIM = 'claim';
exports.CANCELATION_COMMENTS = 'cancelComment';
exports.REITERATION_COMMENTS = 'reiterationComment';
exports.CANCELATION = 'CANCELATION';
exports.REITERATION = 'REITERAITON';
